module.exports = __webpack_public_path__ + "img/D202305_4.7c3aa927.jpg";